/**
 * export file for HomeLayout
 * Author: Chris Hao
 * CreatedAt: 2021-3-4
 */

export { default as HomeLayout } from './HomeLayout';
export { default as SalesChannelHeader } from './SalesChannelHeader';
